import Button from "components/atoms/Button/Button";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import styles from "./style.module.scss";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  getSingleDataWithLinkedin,
  resetSearchData,
} from "store/slices/data.slice";
import Loading from "components/atoms/Loading/Loading";
import { toast } from "react-toastify";
import InputField from "components/atoms/InputField/InputField";

const LeadFormLinkedIn: React.FC = () => {
  const [linkedinValue, setLinkedinValue] = useState("");
  const {
    reset,
    formState: { errors },
  } = useForm<{ linkedInURL: string }>();
  const { isLoading } = useAppSelector((state) => state.data.searchData);
  const dispatch = useAppDispatch();

  const save = async (data: { linkedInURL: string }) => {
    await dispatch(getSingleDataWithLinkedin(data));
    reset();
    setLinkedinValue("");
  };

  const handleSave = (e: any) => {
    e.preventDefault();
    const valid =
      /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile)\/([-a-zA-Z0-9]+)\/*/gm;
    if (!linkedinValue) {
      return toast.error("Please fill a LinkedIn Profile");
    } else if (!valid.test(linkedinValue)) {
      return toast.error("Please fill a valid URL");
    }
    save({ linkedInURL: linkedinValue });
  };

  useEffect(() => {
    return () => {
      dispatch(resetSearchData());
    };
  }, []);

  return <form className={styles.form_oneinput}>
    <InputField
      iconName="linkedin"
      className="sm:w-2/4"
      type="text" 
      size="small"
      disabled={isLoading}
      value={linkedinValue}
      onChange={(e: any) => setLinkedinValue(e.target.value)}
      placeholder="Enter LinkedIn profile URL"
    />
    {isLoading 
      ? <div className="flex items-center gap-3">
        <Loading height="38px" spinnerSize={25} />
        <p>Searching...</p>
      </div>
      : <Button
        className="w-full sm:w-max"
        iconName="search" size="sm"
        onClick={(e: any) => handleSave(e)}
      >Single Search</Button>
    }
  </form>
};

export default LeadFormLinkedIn;
